<template>
  <div>
    <common-header title="성인 콘텐츠 설정" :is-back-btn="true" :back-fn="close" :is-close-btn="false"></common-header>
    <div class="adult-content-settings">
      <div class="lnb-list">
        <ul>
          <li>
            <a href="#" @click.prevent="goProtectChildren">
              <span>자녀보호 설정</span>
              <NextButtonGrey />
            </a>
          </li>
          <li>
            <a href="#" @click.prevent="goSetPinCode">
              <span>성인 비밀번호 설정</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import NextButtonGrey from '@/assets/svg/common/ic-next-s-g.svg'
import utils, { setAdultContentsSettingsValue } from '@/common/util/utils'
import {
  changeAdultContentProtectionStateForOTT,
  getAdultVerificationStatus
} from '@/common/api/api.service'
import {
  CONFIRM_CHILDREN_PROTECTION_MESSAGE_HTML, WHEN_USER_ALLOW_BLOCK_POPUP
} from '@/common/message.const'
import CommonHeader from '@/components/header/template/commonHeader'
import { mapGetters } from 'vuex'
import { removeElement } from '@/common/util/modal.common'
export default {
  name: 'AdultSettingView',
  components: {
    CommonHeader,
    NextButtonGrey
  },
  data () {
    return {
      adultVerification: null,
      hasAdultPassCode: false,
      hasAdultVerification: false,
      alreadySetAdultPassCodeByOTT: false,
      popup: null
    }
  },
  computed: {
    ...mapGetters(['getBeforePathOpenMyPooq'])
  },
  methods: {
    close () {
      this.$router.replace(this.getBeforePathOpenMyPooq)
    },
    goProtectChildren () {
      this.$router.push('/settings/adult/protect')
    },
    changePinCodePopup (protectionCode) {
      const callback = encodeURIComponent(`${window.location.origin}/callback.html?action=setPinCode&result=`)
      const url = `https://member.wavve.com/mobile/auth/adultpin?&device=mobile&credential=${utils.cookies.getCredential()}&settings=${protectionCode}` +
          `&callback=${callback}`
      this.popup = window.open(url, '_blank')
      if (this.popup) {
        this.popup.window.focus()
      } else {
        alert(WHEN_USER_ALLOW_BLOCK_POPUP)
      }
    },
    openAdultVerificationAndSetPinCodePopup (protectionCode) {
      const callback = encodeURIComponent(`${window.location.origin}/callback.html?action=setPinCode&result=`)
      const url = `https://member.wavve.com/mobile/auth/verifyage?type=pin&settings=${protectionCode}` +
          `&device=mobile&credential=${utils.cookies.getCredential()}&callback=${callback}`
      this.popup = window.open(url, '_blank')
      if (this.popup) {
        this.popup.window.focus()
      } else {
        alert(WHEN_USER_ALLOW_BLOCK_POPUP)
      }
    },
    goPinCodePageWithStateCodeForOttUser (stateCode) {
      const popupType = 'adultverify_pin_adult'
      this.$router.replace({
        name: popupType,
        query: {
          referer: this.$route.fullPath
        },
        params: {
          action: this.buildChangeStateAction(stateCode, changeAdultContentProtectionStateForOTT),
          stateCode
        }
      })
    },
    buildChangeStateAction (protectionCode, requestFn) {
      return async ({ pincode, resetFn, successFn }) => {
        try {
          const result = await requestFn(pincode, protectionCode)
          const { resultcode } = result.data
          if (resultcode !== '550') {
            await setAdultContentsSettingsValue()
            if (typeof successFn === 'function') {
              successFn()
            } else {
              this.$router.replace('/settings/adult/protect')
            }
          }
        } catch (e) {
          if (typeof resetFn === 'function') { resetFn() }
        }
      }
    },
    async goSetPinCode () {
      const result = await getAdultVerificationStatus()
      const data = result.data
      const { isverify, isott, settings } = data
      const hasAdultPassCode = isverify !== 'n'
      const alreadySetAdultPassCodeByOTT = isott !== 'n'
      // const hasAdultPassCode = true
      // const alreadySetAdultPassCodeByOTT = true

      if (alreadySetAdultPassCodeByOTT) {
        // if (await utils.asyncConfirm(CONFIRM_CHILDREN_PROTECTION_MESSAGE_HTML)) {
        this.goPinCodePageWithStateCodeForOttUser(settings)
        // }
      } else {
        if (hasAdultPassCode) {
          this.changePinCodePopup(settings)
        } else {
          if (await utils.asyncConfirm(CONFIRM_CHILDREN_PROTECTION_MESSAGE_HTML)) {
            removeElement(document.querySelector('[data-modal="confirm"]'))
            this.openAdultVerificationAndSetPinCodePopup(settings)
          }
        }
      }
    },
    postMessage (e) {
      if (e.origin === location.origin && e.data.eventMessage === 'setPinCode') {
        this.popup.close()
      }
    }
  },
  mounted () {
    window.addEventListener('message', this.postMessage)
  },
  created () {
    // const credential = utils.cookies.getCredential()
    // const openUrl = `https://member.wavve.com/tv/pin/auth/adultpassword?credential=${encodeURIComponent(credential)}`
  },
  beforeDestroy () {
    window.removeEventListener('message', this.postMessage)
  }
}

</script>
<style lang="css" src="@/assets/new-css/home-gnb.css"></style>
<style lang="css" src="@/assets/new-css/lnb.css"></style>
